<template>
  <div class="index">
    <left-nav ref="box" v-if="screenWidth >= 1200"></left-nav>
    <div class="right" :style="{ width: screenWidth >= 1200 ? '81%' : '100%' }">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import leftNav from "./../components/content/leftNav";
import bus from "./../util/bus";
export default {
  components: {
    leftNav,
  },
  data() {
    return {
      screenWidth: "",
      widtd: "81%",
    };
  },
  created() {
    let bgcolor = localStorage.getItem("bgcol");
    let root = document.querySelector(":root");
    root.style.setProperty("--color-theme", bgcolor);
  },
  watch: {
    screenWidth(vul) {
      if (vul <= 1200) {
        this.widtd = "100%";
      } else {
      }
      bus.$emit("widthpm", vul);
    },
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
};
</script>

<style lang="scss">
.index {
  display: flex;
  height: 100%;
  width: 100%;
  .el-drawer__body {
    overflow: hidden;
  }
}

.right {
  height: 100%;
  background-color: var(--color-theme);
}
</style>